import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_startup-proof-1/artifacts/nl94xhsq_Lightbulb%20White.png";

export default function BrandMark({ to = "/" }) {
  return (
    <Link
      to={to}
      data-testid="brand-mark"
      className="inline-flex items-center gap-3 select-none"
    >
      <img
        src={LOGO_URL}
        alt="Lightbulb"
        width="36"
        height="36"
        className="w-9 h-9 object-contain"
        draggable={false}
      />
      <div className="leading-tight">
        <div className="text-base font-bold text-white tracking-tight">
          Greenlight Score
          <span className="text-[#4ADE80] ml-0.5">™</span>
        </div>
        <div className="gl-label-muted text-[10px] leading-none mt-0.5">
          by Lightbulb
        </div>
      </div>
    </Link>
  );
}
